/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SuccessApiResponse } from '../../models/success-api-response';

export interface CheckValidationsAsync$Plain$Params {
  Number?: number;
  Flag?: boolean;
  Message?: string;
}

export function checkValidationsAsync$Plain(http: HttpClient, rootUrl: string, params?: CheckValidationsAsync$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<SuccessApiResponse>> {
  const rb = new RequestBuilder(rootUrl, checkValidationsAsync$Plain.PATH, 'get');
  if (params) {
    rb.query('Number', params.Number, {});
    rb.query('Flag', params.Flag, {});
    rb.query('Message', params.Message, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SuccessApiResponse>;
    })
  );
}

checkValidationsAsync$Plain.PATH = '/api/health-check/validations';
